// extracted by mini-css-extract-plugin
module.exports = {"HealthScoreBar":"HealthScoreBar_HealthScoreBar__XX2d7","text":"HealthScoreBar_text__FIQW1"};